// const Logodark = 'https://d3t7cnf9sa42u5.cloudfront.net/VC_Website_lighting/websiteAssets/NavAssets/LogoDark.svg',
const Logodark = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/NavAssets/LogoDark.webp',
  Logolight = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/NavAssets/LogoWhite.webp',
  darkThemeImg = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/NavAssets/darkTheme.webp',
  lightThemeImg = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/NavAssets/lightTheme.webp';

export { Logodark, Logolight, darkThemeImg, lightThemeImg };
